export const portfolioBalance = {
  POSITIVE_BALANCE: 'Available Wallet Balance',
  ZERO_BALANCE: 'Available Wallet Balance',
};
